import { createSvgIcon } from '@mui/material/utils'

export const KeywordsIcon = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7.50011 7.49977H7.60109M15.0008 18L9.42351 12.502C8.34421 12.9202 7.0547 12.756 5.85676 12.4055C3.00381 11.5709 1.37736 8.61445 2.22398 5.80204C3.07061 2.98963 6.06971 1.38629 8.92266 2.22088C11.7756 3.05548 13.4021 6.01196 12.5554 8.82437L12.4226 9.54548L17.9999 15.0435V18H15.0008Z' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)
